export const LOAD_CB_VERSION = '0.0.23';
